<div class="flex-container">

  <mat-table #table [dataSource]="dataSource" matSort matSortDisableClear="true" class="mat-elevation-z0" *ngIf="dataSource">

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Namn </mat-header-cell>
      <mat-cell *matCellDef="let element" (click)="onRowClick(element)"><span class="user-text">{{element.name}}</span></mat-cell>
    </ng-container>

    <!-- loginID Column -->
    <ng-container matColumnDef="loginID">
      <mat-header-cell *matHeaderCellDef> Inloggning </mat-header-cell>
      <mat-cell *matCellDef="let element" (click)="onRowClick(element)"><span class="user-text">{{element.loginID}}</span></mat-cell>
    </ng-container>

    <!-- roles Column -->
    <ng-container matColumnDef="roles">
      <mat-header-cell *matHeaderCellDef> Roller </mat-header-cell>
      <mat-cell *matCellDef="let element" (click)="onRowClick(element)"><span class="user-text">{{element.skillsExpanded}}</span></mat-cell>
    </ng-container>

     <!--driversCode Column-->
    <ng-container matColumnDef="employmentNumber">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Anställningsnummer </mat-header-cell>
      <mat-cell *matCellDef="let element" (click)="onRowClick(element)"><span class="user-text">{{element.employmentNumber}}</span></mat-cell>
    </ng-container>

     <!--userCheckIn Column-->
    <ng-container matColumnDef="userCheckIn">
      <mat-header-cell *matHeaderCellDef> Checka in/ut </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <mat-slide-toggle [checked]="isCheckedIn(element)" (click)="checkInOrOut(element)" class="check-in-out"></mat-slide-toggle>
      </mat-cell>
    </ng-container>


    <mat-header-row style="background-color:white; position: sticky; top: 0;z-index: 100;" *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>

</div>
